module.exports = __webpack_public_path__ + "img/user_person_manager_employee_leader_businessman_business_man-256.34e64408.png";